import React from "react";

import { Modal, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  maxHeight: "90vh",
  overflowY: "auto",
  borderRadius: "8px",
};

const SourceModal = ({ open, handleClose, data }) => {
  return (
    <>
      <Modal
        open={open}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={style}>
          <IconButton
            onClick={() => {
              handleClose();
            }}
            sx={{ position: "absolute", top: 8, right: 8, color: "gray" }}
          >
            <CloseIcon />
          </IconButton>

          <Typography variant="h6" component="div">
            Sources
          </Typography>
          <hr />

          <ul style={{ listStyleType: "square", paddingLeft: "20px" }}>
            {data?.map((obj, index) => (
              <React.Fragment key={index}>
                <li style={{}}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Typography variant="body1" component="span">
                      {obj}
                    </Typography>
                  </div>
                </li>

                <hr />
              </React.Fragment>
            ))}
          </ul>
        </Box>
      </Modal>
    </>
  );
};

export default SourceModal;
